import { AuthContextProps } from "../components/auth-context";
import { putData } from "./core";

export default class LandingPaymentApi {
  static uri = "payment";
  static UnauthorizedUri = "n/accounts/payment";
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }

  put(
    id: string,
    discountCode: string,
    depositPay: boolean,
    creditPay: boolean, 
    selectedBankId:number
  ) {
    return putData({
      uri: LandingPaymentApi.UnauthorizedUri,
      data: { id, discountCode, depositPay, creditPay,selectedBankId },
      context: this.context,
    });
  }
}
